import React from "react";

const IESplashPage = () => {
  return (
    <div>SMART Technology does not support Internet Explorer.</div>
  )
}

export default IESplashPage;
